import { Aurelia } from 'aurelia-framework';
import { BaseService } from 'Common/BaseService';
import { Config } from 'Config';
import { Layout } from 'Common/Layout/Layout';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { RESTApiAdapter } from '../Adapters/RESTApiAdapter';
import { StringHelper } from 'Code/Helpers/StringHelper';
import { autoinject } from 'aurelia-dependency-injection';
import { EntityTab } from 'Common/Code/Model/EntityTab';
import { DashboardLayout } from 'General/Resources/Elements/Charts/ChartDefinition';

@autoinject
export class SystemService extends BaseService {

    private cache: Object = {};
    private globalUserBlockSettings: Array<any> = null;

    private tokenName: string = Config.TokenName();
    protected static instance: SystemService;
    protected publicHolidaysCzDays: any = {};
    protected static accessRightsEnum = [
        'Read',
        'Create',
        'Edit',
        'Delete',
        'ViewAll',
        'ModifyAll',
        'Export',
        'BulkOperation',
        'Print',
        'Lock',
        'Archive',
        'ManageLayout',
        'ManageDisplayFormat',
        'ManageCategories',
        'ManageParticipants',
        'ManageRowAccess',
        'DiscussionRead',
        'DiscussionCreate',
        'DiscussionEdit',
        'DiscussionDelete',
        'DiscussionViewAll',
        'DiscussionModifyAll',
        'DocumentRead',
        'DocumentCreate',
        'DocumentEdit',
        'DocumentDelete',
        'DocumentViewAll',
        'DocumentModifyAll',
        'TrackChangesRead',
        'EnableAPI',
        'ManageWorkflows',
        'ManageApprovalRules',
        'Import',
        'ReadParticipants',
        'ReminderRead',
        'ReminderCreate',
        'ReminderEdit',
        'ReminderDelete',
        'EditInGrid'
    ];
    private isOnline: boolean = true;

    constructor(restApiAdapter: RESTApiAdapter) {
        super(restApiAdapter);
        this.isOnline = Config.IsOnline();
    }

    static get Instance() {
        if (ObjectHelper.IsNullOrUndefined(this.instance)) {
            this.instance = new SystemService(new Aurelia().container.get(RESTApiAdapter));
        }
        return this.instance;
    }

    static get AccessRightsEnum() {
        return this.accessRightsEnum;
    }

    public SetIsOnline(isOnline: boolean) {
        this.isOnline = isOnline;
    }

    public GetTaxValue(id: number): number {
        const taxs: Array<any> = this.cache[this.tokenName + '_EntityList_Tax'];
        if (ObjectHelper.ArrayIs(taxs)) {
            const tax: any = ObjectHelper.GetFirstItemOfArrayByProperty(taxs, "Id", id);
            if (ObjectHelper.ObjectIs(tax) && tax.Value >= 0) {
                return tax.Value;
            }
        }
        return 0;
    }

    public async ClearCache_All() {
        //https://stackoverflow.com/questions/4391575/how-to-find-the-size-of-localstorage
        //var _lsTotal=0,_xLen,_x;for(_x in localStorage){ if(!localStorage.hasOwnProperty(_x)){continue;} _xLen= ((localStorage[_x].length + _x.length)* 2);_lsTotal+=_xLen; console.log(_x.substr(0,50)+" = "+ (_xLen/1024).toFixed(2)+" KB")};console.log("Total = " + (_lsTotal / 1024).toFixed(2) + " KB");
        //https://stackoverflow.com/questions/29546756/how-to-get-free-local-storage-quota
        //var c1 = 0;  for (var i = 1; i < localStorage.length; i++) { c1 = c1 + (localStorage[localStorage.key(i)]).length; }
        //1024 * 1024 * 5 - unescape(encodeURIComponent(JSON.stringify(localStorage))).length;
        //Math.round((1024 * 1024 * 5 - unescape(encodeURIComponent(JSON.stringify(localStorage))).length) / (1024 * 1024 * 5) * 100);

        this.cache = {};
        this.globalUserBlockSettings = null;
        let tokenName: string = this.tokenName;

        localStorage.removeItem(tokenName + '_schema');
        localStorage.removeItem(tokenName + '_schemaVer');
        localStorage.removeItem(tokenName + '_menu');
        localStorage.removeItem(tokenName + '_schemaFormLogic');
        localStorage.removeItem(tokenName + '_schemaLayout');

        localStorage.removeItem(tokenName + '_IconEntity');
        localStorage.removeItem(tokenName + '_GridTitle');
        localStorage.removeItem(tokenName + '_TitleEntity');
        localStorage.removeItem(tokenName + '_EntityTabs');
        localStorage.removeItem(tokenName + '_CalendarBackgroundColorEntity');
        localStorage.removeItem(tokenName + '_Enum');
        localStorage.removeItem(tokenName + '_SchemaByEntity');
        localStorage.removeItem(tokenName + '_AccRightEnt');
        localStorage.removeItem(tokenName + '_EditLayout');
        localStorage.removeItem(tokenName + '_ColEnumType');
        localStorage.removeItem(tokenName + '_ColEntityName');
        localStorage.removeItem(tokenName + '_ListLayout');
        localStorage.removeItem(tokenName + '_DashLayout');
        localStorage.removeItem(tokenName + '_FilterSett');
        localStorage.removeItem(tokenName + '_GridSettings');
        localStorage.removeItem(tokenName + '_SubGridTitle');
        localStorage.removeItem(tokenName + '_EntityList');
        localStorage.removeItem(tokenName + '_EntityEnum');
        localStorage.removeItem(tokenName + '_EntityEnumById');
        //localStorage.removeItem(tokenName + '_UserStatusInfo');
        //localStorage.removeItem(tokenName + '_MenuStatusInfo');

        //let keyName: string = null;
        //let keys: Array<string> = [];
        //for (var i = 1; i <= localStorage.length; i++) {
        //    keys.push(localStorage.key(i));
        //}
        //for (var i = 1; i <= keys.length; i++) {
        //    keyName = keys[i]
        //    if (StringHelper.IsNotNullAndEmptyAndUndefined(keyName) && keyName != tokenName && keyName.startsWith(tokenName)) {
        //        localStorage.removeItem(keyName);
        //    }
        //}
    }

    public async ClearCache_Layout() {
        console.log('ClearCache_Layout() !!');
        await this.ClearCache_All();
        //localStorage2.removeItem(this.tokenName + 'schemaLayout');
        //this.localCacheLayout = new Collections.Dictionary<string, string>();
    }

    public async ClearCache_Enum() {
        console.log('ClearCache_Enum() !!');
        await this.ClearCache_All();
        //this.localCacheEnum = new Collections.Dictionary<string, string>();
    }

    public async ClearCache_FormLogic() {
        console.log('ClearCache_FormLogic() !!');
        await this.ClearCache_All();
        //localStorage2.removeItem(this.tokenName + 'schemaFormLogic');
        //await this.RestartLocalCache();
    }

    private GetCacheKey(prefix: string, key: string): string {
        let cacheKeyName: string = this.tokenName + '_' + key
        if (StringHelper.IsNotNullAndEmptyAndUndefined(prefix)) {
            cacheKeyName = this.tokenName + '_' + prefix + '_' + key;
        }
        return cacheKeyName;
    }

    public GetPublicHolidaysCz(): any {
        return this.GetStorageItem(null, 'schema').PublicHolidaysCz;
    }

    public IsDatePublicHolidaysCz(date1: Date): boolean {
        const dayString = 'Day' + moment(date1).format('YYYY-MM-DD');
        if (ObjectHelper.ObjectIs(this.publicHolidaysCzDays[dayString])) {
            return this.publicHolidaysCzDays[dayString];
        }
        const publicHolidaysCz = this.GetStorageItem(null, 'schema').PublicHolidaysCz;
        if (ObjectHelper.ObjectIs(date1) && ObjectHelper.ObjectIs(publicHolidaysCz)) {
            if (!this.publicHolidaysCzDays.hasOwnProperty(dayString)) {
                const year = date1.getFullYear();
                if (ObjectHelper.ArrayIs(publicHolidaysCz['Year' + year])) {
                    //console.log(555, moment(date1).format('YYYY-MM-DD'), date1, this.publicHolidaysCz['Year'+year]);
                    this.publicHolidaysCzDays[dayString] = publicHolidaysCz['Year' + year].indexOf(moment(date1).format('YYYY-MM-DD')) >= 0;
                }
            }
            if (ObjectHelper.ObjectIs(this.publicHolidaysCzDays[dayString])) {
                return this.publicHolidaysCzDays[dayString];
            }
        }
        return false;
    }

    public GetStorageItem(prefix: string, key: string): any {
        let val: string = this.GetStorageItemString(prefix, key);
        try {
            return JSON.parse(val);
        } catch (e) {
            return val;
        }
        return null;
    }
    public ExistsStorageItem(prefix: string, key: string): boolean {

        if (StringHelper.IsNullOrEmptyOrUndefined(key)) {
            return false;
        }

        let cacheKeyName: string = this.GetCacheKey(prefix, key);

        return (cacheKeyName in this.cache) && true;
    }


    public GetStorageItemString(prefix: string, key: string): string {

        if (StringHelper.IsNullOrEmptyOrUndefined(key)) {
            return null;
        }

        let cacheKeyName: string = this.GetCacheKey(prefix, key);

        if (ObjectHelper.IsNotNullAndUndefinedAndEmpty(this.cache[cacheKeyName])) {
            return this.cache[cacheKeyName];
        }

        if (StringHelper.IsNullOrEmpty(prefix)) {
            return localStorage[cacheKeyName];
        }
        else {
            let locStorString: string = localStorage[this.tokenName + '_' + prefix];
            let locStorObj: any = {};
            if (StringHelper.IsNotNullAndEmptyAndUndefined(locStorString) && locStorString.startsWith('{')) {
                locStorObj = JSON.parse(locStorString);
                let val = locStorObj[key];

                if (StringHelper.IsNotNullAndEmptyAndUndefined(val)) {
                    try {
                        this.cache[cacheKeyName] = JSON.parse(val);
                    } catch (e) {
                        this.cache[cacheKeyName] = val;
                    }
                }

                return val;
            }
        }
        return null;
    }

    public SetStorageItem(prefix: string = null, key: string, val: string) {
        if (StringHelper.IsNullOrEmptyOrUndefined(key)) {
            return;
        }
        let cacheKeyName: string = this.GetCacheKey(prefix, key);

        this.cache[cacheKeyName] = val;
        if (StringHelper.IsNotNullAndEmptyAndUndefined(val)) {
            try {
                this.cache[cacheKeyName] = JSON.parse(val);
            } catch (e) {
                this.cache[cacheKeyName] = val;
            }
        }

        if (StringHelper.IsNullOrEmpty(prefix)) {
            if (key != 'SchemaByEntity' && key != 'schemaLayout' || this.tokenName == "FirmaTest11Token") {
                localStorage[this.tokenName + '_' + key] = val;
            }
        }
        else {
            if (prefix != 'SchemaByEntity' && prefix != 'schemaLayout' || this.tokenName == "FirmaTest11Token") {
                let locStorString: string = localStorage[this.tokenName + '_' + prefix];
                let locStorObj: any = {};
                if (StringHelper.IsNotNullAndEmptyAndUndefined(locStorString) && locStorString.startsWith('{')) {
                    locStorObj = JSON.parse(locStorString);
                }
                locStorObj[key] = val;
                if (StringHelper.IsNotNullAndEmptyAndUndefined(val)) {
                    try {
                        locStorObj[key] = JSON.parse(val);
                    } catch (e) {
                        locStorObj[key] = val;
                    }
                }
                localStorage[this.tokenName + '_' + prefix] = JSON.stringify(locStorObj);
            }
        }
    }

    public async SetCacheIconsAndTitle(globalSchema) {
        let locale: string = this.restApiAdapter.GetLocale();

        if (ObjectHelper.IsNotNullAndUndefined(globalSchema)) {
            for (var index = 0; index < globalSchema['Entities'].length; index++) {
                const localCahecKe = globalSchema['Entities'][index]['EntityName'];

                const icon: string = globalSchema['Entities'][index]['Icon'];
                this.SetStorageItem('IconEntity', localCahecKe, icon)

                this.SetStorageItem('GridTitle', localCahecKe, globalSchema['Entities'][index]['EntityListTitle'])

                this.SetStorageItem('TitleEntity', localCahecKe, globalSchema['Entities'][index]['EntityNameTitle'])

                let calendarBackgroundColor: string = globalSchema['Entities'][index]['CalendarBackgroundColor'];
                this.SetStorageItem('CalendarBackgroundColorEntity', localCahecKe, calendarBackgroundColor)

                let entityTabs: Array<EntityTab> = await this.CreateEntityTabs(locale, globalSchema['Entities'][index], globalSchema['Entities'][index]['EntityName'], globalSchema);
                //console.log(777, locale, globalSchema['Entities'][index]['EntityName'], entityTabs);
                this.SetStorageItem('EntityTabs', localCahecKe, JSON.stringify(entityTabs))
            }
        }
    }

    public async CreateEntityTabs(locale: string, schema, entityName: string, globalSchema: any): Promise<Array<EntityTab>> {
        let recordListTabs: Array<EntityTab> = [new EntityTab('DataGrid', 'DataGrid', '', null)];
        recordListTabs[0].Caption = schema['EntityListTitle'];

        if (schema['GanttEnabled']) {
            recordListTabs.push(new EntityTab('Gantt', 'Gantt', 'Gantt diagram', null));
        }

        if (ObjectHelper.ObjectIs(schema['Config']) && ObjectHelper.ObjectIs(schema['Config']['DhtmlxGrid'])
            && ObjectHelper.ObjectIs(schema['Config']['DhtmlxGrid']['Enabled']) && schema['Config']['DhtmlxGrid']['Enabled'] == true) {
            recordListTabs.push(new EntityTab('DataGrid2', 'DataGrid2', schema['EntityListTitle'], null));
        }

        if (ObjectHelper.IsNotNullAndUndefined(schema['KanbanConfig']) && ObjectHelper.IsNotNullAndUndefined(schema['KanbanConfig']['Kanbans'])) {
            for (let iK = 0; iK < schema['KanbanConfig']['Kanbans'].length; iK++) {
                recordListTabs.push(
                    new EntityTab(
                        'Kanban'
                        , schema['KanbanConfig']['Kanbans'][iK]['Id']
                        , StringHelper.StringIs(schema['KanbanConfig']['Kanbans'][iK]['Caption_' + locale]) ? schema['KanbanConfig']['Kanbans'][iK]['Caption_' + locale] : schema['KanbanConfig']['Kanbans'][iK]['Caption']
                        , schema['KanbanConfig']['Kanbans'][iK]
                    )
                );
            }
        }

        if (ObjectHelper.IsNotNullAndUndefined(schema['Config']) && ObjectHelper.IsNotNullAndUndefined(schema['Config']['IndexGoogleMapsConfig'])) {
            for (let iK = 0; iK < schema['Config']['IndexGoogleMapsConfig'].length; iK++) {
                recordListTabs.push(
                    new EntityTab(
                        'GoogleMaps'
                        , schema['Config']['IndexGoogleMapsConfig'][iK]['Id']
                        , StringHelper.StringIs(schema['Config']['IndexGoogleMapsConfig'][iK]['Caption_' + locale]) ? schema['Config']['IndexGoogleMapsConfig'][iK]['Caption_' + locale] : schema['Config']['IndexGoogleMapsConfig'][iK]['Caption']
                        , schema['Config']['IndexGoogleMapsConfig'][iK]
                    )
                );
            }
        }

        if (ObjectHelper.IsNotNullAndUndefined(schema['Config']) && ObjectHelper.IsNotNullAndUndefined(schema['Config']['IndexGoogleMapsRouteConfig'])) {
            for (let iK = 0; iK < schema['Config']['IndexGoogleMapsRouteConfig'].length; iK++) {
                recordListTabs.push(
                    new EntityTab(
                        'GoogleMapsRoute'
                        , schema['Config']['IndexGoogleMapsRouteConfig'][iK]['Id']
                        , StringHelper.StringIs(schema['Config']['IndexGoogleMapsRouteConfig'][iK]['Caption_' + locale]) ? schema['Config']['IndexGoogleMapsRouteConfig'][iK]['Caption_' + locale] : schema['Config']['IndexGoogleMapsRouteConfig'][iK]['Caption']
                        , schema['Config']['IndexGoogleMapsRouteConfig'][iK]
                    )
                );
            }
        }

        if (entityName != 'NotificationOverview' && entityName != 'DiscussionMessageOverview') {
            recordListTabs.push(new EntityTab('TrackChanges', 'TrackChanges', locale == 'cs' ? 'Záznam změn' : 'Track Changes', null));
        }

        if (ObjectHelper.IsNotNullAndUndefined(schema['Config']) && ObjectHelper.IsNotNullAndUndefined(schema['Config']['IndexSchedulerByUnitConfig'])) {
            for (let iK = 0; iK < schema['Config']['IndexSchedulerByUnitConfig'].length; iK++) {
                recordListTabs.push(
                    new EntityTab(
                        'SchedulerByUnit'
                        , schema['Config']['IndexSchedulerByUnitConfig'][iK]['Id']
                        , StringHelper.StringIs(schema['Config']['IndexSchedulerByUnitConfig'][iK]['Caption_' + locale]) ? schema['Config']['IndexSchedulerByUnitConfig'][iK]['Caption_' + locale] : schema['Config']['IndexSchedulerByUnitConfig'][iK]['Caption']
                        , schema['Config']['IndexSchedulerByUnitConfig'][iK]
                    )
                );
            }
        }

        if (ObjectHelper.IsNotNullAndUndefined(schema['Config']) && ObjectHelper.IsNotNullAndUndefined(schema['Config']['IndexSchedulerRentalConfig'])) {
            for (let iK = 0; iK < schema['Config']['IndexSchedulerRentalConfig'].length; iK++) {
                schema['Config']['IndexSchedulerRentalConfig'][iK].ItemRecords = schema['Config']['IndexSchedulerRentalConfig'][iK].ItemRecords.filter((item) =>
                    ObjectHelper.ArrayIndexByProperty(globalSchema.Entities, 'EntityName', item['EntityName']) > 0);
                recordListTabs.push(
                    new EntityTab(
                        'SchedulerRental'
                        , schema['Config']['IndexSchedulerRentalConfig'][iK]['Id']
                        , StringHelper.StringIs(schema['Config']['IndexSchedulerRentalConfig'][iK]['Caption_' + locale]) ? schema['Config']['IndexSchedulerRentalConfig'][iK]['Caption_' + locale] : schema['Config']['IndexSchedulerRentalConfig'][iK]['Caption']
                        , schema['Config']['IndexSchedulerRentalConfig'][iK]
                    )
                );
            }
        }
        return recordListTabs;
    }

    public SetOptimCallAgentState(data: any) {
        //console.log(5555, data);
        if (ObjectHelper.ObjectIs(data)) {
            const cacheKeyName: string = this.GetCacheKey('OptimCallAgentState', data.UserId + '');
            this.cache[cacheKeyName] = data;
        }
        //console.log(6666, this.cache);
    }

    public GetOptimCallAgentState(userId: number): number {
        if (userId > 0) {
            const cacheKeyName: string = this.GetCacheKey('OptimCallAgentState', userId + '');
            //console.log(5555, this.cache, cacheKeyName);
            const status: any = this.cache[cacheKeyName];
            if (ObjectHelper.ObjectIs(status)) {
                return status.ActivityStatus;
            }
        }
        return 0;
    }

    public SetUsersActivityStatus(data: any) {
        //console.log(5555, data);
        if (ObjectHelper.ArrayIs(data)) {
            for (let i1 = 0; i1 < data.length; i1++) {
                const cacheKeyName: string = this.GetCacheKey('UserActivityStatus', data[i1].UserId + '');
                this.cache[cacheKeyName] = data[i1];
            }
        }
        //console.log(6666, this.cache);
    }

    public GetUserActivityStatus(userId: number): number {
        if (userId > 0) {
            const cacheKeyName: string = this.GetCacheKey('UserActivityStatus', userId + '');
            //console.log(5555, this.cache, cacheKeyName);
            const status: any = this.cache[cacheKeyName];
            if (ObjectHelper.ObjectIs(status)) {
                return status.ActivityStatus;
            }
        }
        return 0;
    }

    public GetUserActiveMinutesAgo(userId: number): number {
        if (userId > 0) {
            const cacheKeyName: string = this.GetCacheKey('UserActivityStatus', userId + '');
            const status: any = this.cache[cacheKeyName];
            if (ObjectHelper.ObjectIs(status)) {
                return status.ActiveMinutesAgo;
            }
        }
        return null;
    }

    public async GetUsersActivityStatus() {
        let body = ObjectHelper.Empty();
        body['GetUsersActivityStatusParam'] = {}
        let response = await this.restApiAdapter.Execute(body);
        if (ObjectHelper.ObjectIs(response) && ObjectHelper.ObjectIs(response.data)) {
            this.SetUsersActivityStatus(response.data);
        }
    }

    public async GetSchema(force?: boolean): Promise<Object> {
        let globalSchema: Object = this.GetStorageItem(null, 'schema');
        if (ObjectHelper.IsNotNullAndUndefined(globalSchema) && (ObjectHelper.IsNullOrUndefined(force) || force == false)) {
            return globalSchema;
        }

        let body = ObjectHelper.Empty();
        body['GetSchema'] = {}
        let response = await this.restApiAdapter.Execute(body);

        if (ObjectHelper.IsNotNullAndUndefined(response) && response.hasOwnProperty('data')) {
            this.SetStorageItem(null, 'schema', JSON.stringify(response['data']));
            this.SetStorageItem(null, 'schemaVer', response['schema_ver']);
            await this.SetCacheIconsAndTitle(response['data']);
            return this.GetStorageItem(null, 'schema');
        }
        return null;
    }

    public async GetSchemaFormLogic(): Promise<Object> {
        let globalSchema: Object = this.GetStorageItem(null, 'schemaFormLogic');
        if (ObjectHelper.IsNotNullAndUndefined(globalSchema)) {
            return globalSchema;
        }

        let body = ObjectHelper.Empty();
        body['GetSchemaFormLogic'] = {}
        let response = await this.restApiAdapter.Execute(body);

        if (ObjectHelper.IsNotNullAndUndefined(response) && response.hasOwnProperty('data')) {
            this.SetStorageItem(null, 'schemaFormLogic', JSON.stringify(response['data']));
            return this.GetStorageItem(null, 'schemaFormLogic');
        }
        return null;
    }

    public async GetSchemaLayout(): Promise<Object> {
        let globalSchema: Object = this.GetStorageItem(null, 'schemaLayout');
        if (ObjectHelper.IsNotNullAndUndefined(globalSchema)) {
            return globalSchema;
        }

        let body = ObjectHelper.Empty();
        body['GetSchemaLayout'] = {}
        let response = await this.restApiAdapter.Execute(body);

        if (ObjectHelper.ObjectIs(response) && ObjectHelper.ObjectIs('data')) {
            //https://esw.myvistos.com/#/Case/edit/69025
            let layouts: any = response['data'];
            if (ObjectHelper.ObjectIs(layouts) && ObjectHelper.ArrayIs(layouts.Entities)) {
                for (let i1 = 0; i1 < layouts.Entities.length; i1++) {
                    if (ObjectHelper.ObjectIs(layouts.Entities[i1]) && ObjectHelper.ArrayIs(layouts.Entities[i1].ProjectionRelationConfigs)) {
                        if (ObjectHelper.ObjectIs(layouts.Entities[i1].LayoutEdit) && ObjectHelper.ArrayIs(layouts.Entities[i1].LayoutEdit.Subgrids)) {
                            for (let i2 = 0; i2 < layouts.Entities[i1].ProjectionRelationConfigs.length; i2++) {
                                for (let i3 = 0; i3 < layouts.Entities[i1].LayoutEdit.Subgrids.length; i3++) {
                                    if (layouts.Entities[i1].LayoutEdit.Subgrids[i3].ProjectionRelationName == layouts.Entities[i1].ProjectionRelationConfigs[i2].Name) {
                                        layouts.Entities[i1].LayoutEdit.Subgrids[i3].Config == layouts.Entities[i1].ProjectionRelationConfigs[i2].Config;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            this.SetStorageItem(null, 'schemaLayout', JSON.stringify(layouts));
            return this.GetStorageItem(null, 'schemaLayout');
        }
        return null;
    }

    public async GetMenu(): Promise<Object> {
        let globalSchema: Object = this.GetStorageItem(null, 'menu');
        if (ObjectHelper.IsNotNullAndUndefined(globalSchema)) {
            return globalSchema;
        }

        let body = ObjectHelper.Empty();
        body['GetMenu'] = {}
        let response = await this.restApiAdapter.Execute(body);
        if (ObjectHelper.IsNotNullAndUndefined(response) && response.hasOwnProperty('data')) {
            if (ObjectHelper.ObjectIs(response['data'])) {
                let menuPars = response['data']['main'];
                menuPars.forEach(element => {
                    if (StringHelper.IsNotNullAndEmptyAndUndefined(element.Filter)) {
                        element.Filter = window.btoa(JSON.stringify(element.Filter));
                    }
                    if (element.hasOwnProperty('Submenu')) {
                        if (element['Submenu'] != null) {
                            element['Submenu'].forEach(item => {
                                if (StringHelper.IsNotNullAndEmptyAndUndefined(item.Filter)) {
                                    item.Filter = window.btoa(JSON.stringify(item.Filter));
                                }
                            });
                        }
                    }
                });
            }

            this.SetStorageItem(null, 'menu', JSON.stringify(response['data']));
            return this.GetStorageItem(null, 'menu');
        }
        return null;
    }

    public GetIconByEntity(entityName: string): string {
        let item: string = this.GetStorageItemString('IconEntity', entityName);
        if (ObjectHelper.IsNotNullAndUndefined(item)) {
            return item;
        }
        return null;
    }

    public GetCalendarBackgroundColorByEntity(entityName: string): string {
        let item: string = this.GetStorageItemString('CalendarBackgroundColorEntity', entityName);
        if (ObjectHelper.IsNotNullAndUndefined(item)) {
            return item;
        }
        return null;
    }

    public async GetSubGridTitleByEntity(parentEntityName: string, entityName: string, projectionRelationName: string): Promise<string> {
        let item: string = this.GetStorageItemString('SubGridTitle', projectionRelationName);
        if (ObjectHelper.IsNotNullAndUndefined(item)) {
            return item;
        }

        let parentEntitSchema: any = await this.GetSchemaByEntity(parentEntityName);
        let entitySchema: any = await this.GetSchemaByEntity(entityName);
        let title: string = entitySchema['SubgridTitle'];
        if (parentEntitSchema['SubGrid'] != null && parentEntitSchema['SubGrid'].length > 0) {
            for (var index = 0; index < parentEntitSchema['SubGrid'].length; index++) {
                if (parentEntitSchema['SubGrid'][index]['ProjectionRelationName'] == projectionRelationName && StringHelper.IsNotNullAndEmptyAndUndefined(parentEntitSchema['SubGrid'][index]['Title'])) {
                    title = parentEntitSchema['SubGrid'][index]['Title'];
                }
            }
        }
        this.SetStorageItem('SubGridTitle', projectionRelationName, title);
        return title;
    }

    public GetGridTitleByEntity(entityName: string): string {
        let item: string = this.GetStorageItemString('GridTitle', entityName);
        if (ObjectHelper.IsNotNullAndUndefined(item)) {
            return item;
        }
    }

    public GetTitleByEntity(entityName: string): string {
        let item: string = this.GetStorageItemString('TitleEntity', entityName);
        if (ObjectHelper.IsNotNullAndUndefined(item)) {
            return item;
        }
    }

    public GetTabsByEntity(entityName: string): Array<EntityTab> {
        let item: Array<EntityTab> = this.GetStorageItem('EntityTabs', entityName);
        if (ObjectHelper.IsNotNullAndUndefined(item)) {
            return item;
        }
    }

    public async GetLayoutsByEntity(entityName: string): Promise<Object> {
        if (!StringHelper.StringIs(entityName)) {
            return null;
        }
        let schemaLayout = await this.GetSchemaLayout();

        if (ObjectHelper.IsNotNullAndUndefined(schemaLayout) && schemaLayout.hasOwnProperty('Entities')) {
            let entity: any = ObjectHelper.GetFirstItemOfArrayByProperty(schemaLayout['Entities'], 'EntityName', entityName);
            if (ObjectHelper.IsNotNullAndUndefined(entity)) {
                return JSON.parse(JSON.stringify(entity));
            }
        }
        return null;
    }

    public async GetColumnListToIgnore(entityName: string): Promise<Array<string>> {
        let originDataIgnore: Array<string> = [
            "Total_WithoutTax_WithoutDiscounts",
            "Total_Tax_WithoutDiscounts",
            "Total_WithoutDiscounts",
            "Total_WithoutTax_WithDiscounts",
            "Total_Tax_WithDiscounts",
            "Total_WithDiscounts",
            "Participant",
            "QueueOrder",
            "PriceWithTax",
            "PriceWithoutTax",
            "PriceTax",
            "AmountPaid",
            "AmountPaidProformaInvoice",
            "RemainToPay",
            "Price1WithoutTax",
            "Price1Tax",
            "Price1WithTax",
            "Price1Tax_FK",
            "Price2WithoutTax",
            "Price2Tax",
            "Price2WithTax",
            "Price2Tax_FK",
            "Price3WithoutTax",
            "Price3Tax",
            "Price3WithTax",
            "Price3Tax_FK",
            "Price4WithoutTax",
            "Price4Tax",
            "Price4WithTax",
            "Price4Tax_FK",
            "Discount",
            "IsPaid",
            "TotalCost",
            "Profit",
            "TotalMargin",
            "TotalAddition",
            "Margin",
            "Addition",
            "Document",
            "TotalPrice",
            "PriceCost",
            "PriceSale",
            "RowCssBackgroundColor",
            "ReminderManualDynamic",
            "TempColumnRecalculation",
            "InvoiceDueDays",
            "MemberTitle"
        ];
        let schema = await this.GetSchemaByEntity(entityName);
        let columns = schema['Columns'].filter(item => item.IsReadOnly == true);
        if (ObjectHelper.ArrayIs(columns)) {
            for (let i1 = 0; i1 < columns.length; i1++) {
                originDataIgnore.push(columns[i1]['ColumnName']);
            }
        }
        return originDataIgnore;
    }

    public async GetStringFromErrorList(errList: any, schema: any): Promise<string> {
        let mess = '';
        if (ObjectHelper.ArrayIs(errList)) {
            for (let i1 = 0; i1 < errList.length; i1++) {
                const item1: any = errList[i1];
                mess = mess + await this.GetPathLocalizationString(item1, schema) + " - " + item1.Message;
                if (StringHelper.StringIs(item1.Value)) {
                    mess = mess + " - " + item1.Value
                }
                mess = mess + '\n';
            }
        }
        return mess;
    }

    public async GetPathLocalizationString(item1: any, schema: any): Promise<string> {
        let loc: string = '';
        if (StringHelper.StringIs(item1.Path)) {
            const paths: Array<string> = item1.Path.split('.');
            for (let i1 = 0; i1 < paths.length; i1++) {
                if (StringHelper.StringIs(loc)) {
                    loc = loc + ' - ';
                }
                if ((i1 + 1) == paths.length) {
                    const column: any = ObjectHelper.GetFirstItemOfArrayByProperty(schema['Columns'], 'ColumnName', paths[i1]);
                    if (ObjectHelper.ObjectIs(column) && StringHelper.StringIs(column.LocalizationString)) {
                        loc = loc + column.LocalizationString;
                    }
                }
                else {
                    if (paths[i1].indexOf('[') > 0) {
                        const entityName: string = paths[i1].substring(0, paths[i1].indexOf('['));
                        schema = await SystemService.Instance.GetSchemaByEntity(entityName);
                        loc = loc + schema.EntityNameTitle;
                    }
                }
            }
        }

        if (StringHelper.IsNullOrEmptyOrUndefined(loc)) {
            loc = item1.Path;
        }

        return loc;
    }

    public async GetSchemaByEntity(entityName: string, force: boolean = false): Promise<Object> {
        if (!force) {
            if (!StringHelper.StringIs(entityName)) {
                console.log('ERR GetSchemaByEntity entityName is NULL');
                return null;
            }
            let entitySchema: Object = this.GetStorageItem('SchemaByEntity', entityName);
            if (ObjectHelper.IsNotNullAndUndefined(entitySchema)) {
                return JSON.parse(JSON.stringify(entitySchema));
            }
        }

        if (entityName == 'CalendarFilter') {
            const globalSchema = await this.GetSchema();
            let data = {
                "EntityName": "CalendarFilter",
                "FilterExpanded": false,
                "Columns": []
            };
            //if (userInfo['AccessToOthersCalendar'] === true) {
            //    let loc1: string = 'Kalendář uživatele';
            //    switch (globalSchema['Language'].toLowerCase()) {
            //        case 'en-us':
            //            loc1 = 'Calendar of the user';
            //            break;
            //        case 'sk-sk':
            //            loc1 = 'Kalendár užívateľa';
            //            break;
            //        case 'de-de':
            //            loc1 = 'Benutzerkalender';
            //            break;
            //    }
            //    let col3 = {
            //        "ColumnName": 'UserID',
            //        "Type_FK": 21,
            //        "EntityNameType_FK": "User",
            //        "Nullable": true,
            //        "VisibleOnGrid": 0,
            //        "IsVisibleOnItemGrid": false,
            //        "IsVisibleOnForm": false,
            //        "IsVisibleOnFilter": true,
            //        "IsReadOnly": true,
            //        "IsVisibleOnTooltip": false,
            //        "EnablePickerCreate": false,
            //        "EnableGetSimpleTooltip": false,
            //        "LocalizationString": loc1,
            //        "Tooltip": ""
            //    }
            //    data['Columns'].push(col3);
            //}
            for (let enIx in globalSchema['Entities']) {
                let entity = globalSchema['Entities'][enIx];
                if (entity['IsCalendarObject'] == true) {
                    let col1 = {
                        "ColumnName": entity['EntityName'],
                        "Type_FK": 30,
                        "EntityNameType_FK": null,
                        "Nullable": true,
                        "VisibleOnGrid": 0,
                        "IsVisibleOnItemGrid": false,
                        "IsVisibleOnForm": false,
                        "IsVisibleOnFilter": true,
                        "IsReadOnly": true,
                        "IsVisibleOnTooltip": false,
                        "EnablePickerCreate": false,
                        "EnableGetSimpleTooltip": false,
                        "LocalizationString": entity['EntityNameTitle'],
                        "Tooltip": ""
                    }
                    data['Columns'].push(col1);

                    let col2 = {
                        "ColumnName": 'Roles_' + entity['EntityName'],
                        "Type_FK": 21,
                        "EntityNameType_FK": 'Role',
                        "Nullable": true,
                        "VisibleOnGrid": 0,
                        "IsVisibleOnItemGrid": false,
                        "IsVisibleOnForm": false,
                        "IsVisibleOnFilter": true,
                        "IsReadOnly": true,
                        "IsVisibleOnTooltip": false,
                        "EnablePickerCreate": false,
                        "EnableGetSimpleTooltip": false,
                        "LocalizationString": 'Role ' + entity['EntityNameTitle'],
                        "Tooltip": ""
                    }
                    data['Columns'].push(col2);
                }
            }
            this.SetStorageItem('SchemaByEntity', entityName, JSON.stringify(data));
            return this.GetStorageItem('SchemaByEntity', entityName);
        }
        else {
            let body = ObjectHelper.Empty();
            body['GetSchemaEntity'] = {
                "EntityName": entityName,
                "Force": force
            }

            let response = await this.restApiAdapter.Execute(body);

            if (ObjectHelper.IsNotNullAndUndefined(response) && response.hasOwnProperty('data')) {
                let entity = response['data'];
                if (ObjectHelper.IsNotNullAndUndefined(entity)) {
                    {
                        //#region "set FormLogic to Entity and Columns"
                        let schemaFormLogic = await this.GetSchemaFormLogic();
                        if (ObjectHelper.IsNotNullAndUndefined(schemaFormLogic) && schemaFormLogic.hasOwnProperty('Entities')) {
                            let entityFormLogic: any = ObjectHelper.GetFirstItemOfArrayByProperty(schemaFormLogic['Entities'], 'EntityName', entityName);
                            if (ObjectHelper.IsNotNullAndUndefined(entityFormLogic)) {
                                entity.FormLogic = JSON.parse(JSON.stringify(entityFormLogic.FormLogic));
                                if (ObjectHelper.ArrayIs(entity.Columns) && ObjectHelper.ArrayIs(entityFormLogic.Columns)) {
                                    for (let i1 = 0; i1 < entity.Columns.length; i1++) {
                                        let entityFormLogicCol: any = ObjectHelper.GetFirstItemOfArrayByProperty(entityFormLogic.Columns, 'ColumnName', entity.Columns[i1].ColumnName)
                                        if (ObjectHelper.IsNotNullAndUndefined(entityFormLogicCol) && ObjectHelper.IsNotNullAndUndefined(entityFormLogicCol.FormLogic)) {
                                            entity.Columns[i1].StdFormLogic = JSON.parse(JSON.stringify(entityFormLogicCol.FormLogic));
                                        }
                                    }
                                }
                            }
                        }
                        //#endregion "set FormLogic to Entity and Columns"
                    }
                    {
                        //#region "get Enum and Entity lists"
                        if (ObjectHelper.ArrayIs(entity.Columns)) {
                            for (let i1 = 0; i1 < entity.Columns.length; i1++) {
                                //entity.Columns[i1]
                                switch (entity.Columns[i1].Type_FK) {
                                    case 8:
                                    case 9:
                                    case 40:
                                        if (StringHelper.StringIs(entity.Columns[i1].EnumType)) {
                                            entity.Columns[i1].EnumItems = await this.GetEnumeration(entity.Columns[i1].EnumType, null, null);
                                        }
                                        break;
                                    case 21:
                                        if (StringHelper.StringIs(entity.Columns[i1].EntityNameType_FK)) {
                                            entity.Columns[i1].EnumItems = await this.GetEntityList(entity.Columns[i1].EntityNameType_FK, null);
                                        }
                                }
                            }
                        }
                        //#endregion "get Enum and Entity lists"
                    }

                    this.SetStorageItem('SchemaByEntity', entityName, JSON.stringify(entity));
                    return this.GetStorageItem('SchemaByEntity', entityName);
                }
            }

        }
        return null;
    }

    public async GetAccessRightByEntity(entityName: string): Promise<Object> {
        if (!StringHelper.StringIs(entityName)) {
            return null;
        }

        let itemA: Object = this.GetStorageItem('AccRightEnt', entityName);
        if (ObjectHelper.IsNotNullAndUndefined(itemA)) {
            return itemA;
        }
        let schema = await this.GetSchemaByEntity(entityName);

        if (ObjectHelper.IsNotNullAndUndefined(schema) && schema.hasOwnProperty('AccessRight')) {
            this.SetStorageItem('AccRightEnt', entityName, JSON.stringify(schema['AccessRight']));
            return this.GetStorageItem('AccRightEnt', entityName);
        }
        else {
            return null;
        }
    }

    public async GetSchemaProperty(property: string): Promise<any> {
        return (await this.GetSchema())[property]
    }

    public async GetEnumType(entityName: string, columnName: string): Promise<string> {
        if (entityName == 'DiscussionFilter' && columnName == 'Responsible_FK') {
            return 'VistosUser';
        }
        else {
            let localCahecKey = entityName + columnName;
            let itemA: string = this.GetStorageItemString('ColEnumType', localCahecKey);
            if (StringHelper.IsNotNullAndEmptyAndUndefined(itemA)) {
                return itemA;
            }

            let schema = await this.GetSchemaByEntity(entityName);
            if (ObjectHelper.IsNotNullAndUndefined(schema) && schema.hasOwnProperty('Columns')) {
                let columns = schema['Columns'].filter(item => item.ColumnName == columnName);
                if (ObjectHelper.IsNotNullAndUndefined(columns) && columns.length > 0) {
                    if (columns[0].hasOwnProperty('EnumType')) {
                        this.SetStorageItem('ColEnumType', localCahecKey, columns[0]['EnumType']);
                        return this.GetStorageItem('ColEnumType', localCahecKey);
                    }
                }
            }
            return null;
        }
    }

    public async GetEntityColumnTypeId(entityName: string, columnName: string): Promise<number> {

        let localCahecKey = entityName + columnName;
        let itemA: string = this.GetStorageItemString('ColTypeId', localCahecKey);
        if (StringHelper.IsNotNullAndEmptyAndUndefined(itemA)) {
            return Number(itemA);
        }

        let schema = await this.GetSchemaByEntity(entityName);
        if (ObjectHelper.IsNotNullAndUndefined(schema) && schema.hasOwnProperty('Columns')) {
            let columns = schema['Columns'].filter(item => item.ColumnName == columnName);
            if (ObjectHelper.IsNotNullAndUndefined(columns) && columns.length > 0) {
                if (columns[0].hasOwnProperty('Type_FK')) {
                    this.SetStorageItem('ColTypeId', localCahecKey, columns[0]['Type_FK']);
                    return Number(this.GetStorageItem('ColTypeId', localCahecKey));
                }
            }
        }
        return null;
    }

    public async GetEntityName(entityName: string, columnName: string) {
        if (entityName == 'TextTemplate' && columnName == 'TextTemplate_FK') {
            return 'TextTemplate';
        }
        if (entityName == 'DirectoryGps' && columnName == 'MapItemOriginId' || entityName == 'DirectoryGps' && columnName == 'MapItemDestinationId') {
            return 'DirectoryGps';
        }
        let localCahecKey = entityName + columnName;
        let itemA: string = this.GetStorageItemString('ColEntityName', localCahecKey);
        if (StringHelper.IsNotNullAndEmptyAndUndefined(itemA)) {
            return itemA;
        }

        let schema = await this.GetSchemaByEntity(entityName);
        if (ObjectHelper.IsNotNullAndUndefined(schema) && schema.hasOwnProperty('Columns')) {
            let columns = schema['Columns'].filter(item => item.ColumnName == columnName);
            if (ObjectHelper.IsNotNullAndUndefined(columns) && columns.length > 0) {
                if (columns[0].hasOwnProperty('EntityNameType_FK')) {
                    this.SetStorageItem('ColEntityName', localCahecKey, columns[0]['EntityNameType_FK']);
                    return this.GetStorageItem('ColEntityName', localCahecKey);
                }
            }
        }
        return null;
    }

    public async FilterEntityList(entityName: string, filterText: string): Promise<Array<Object>> {

        if (StringHelper.IsNullOrEmptyOrUndefined(entityName))
            return null;

        let body = ObjectHelper.Empty();
        body['GetEntityListParam'] = {
            "EntityName": entityName,
            "FilterText": filterText
        }

        let response = await this.restApiAdapter.Execute(body);
        if (ObjectHelper.IsNotNullAndUndefined(response) && response.hasOwnProperty('data')) {
            let data = response['data'];
            return response['data'];
        }
        return null;
    }

    public async GetEntityList(entityName: string, parentValue: number): Promise<Array<Object>> {
        if (StringHelper.IsNullOrEmptyOrUndefined(entityName))
            return null;

        let localCahecKey = entityName;
        if (ObjectHelper.IsNotNullAndUndefined(parentValue)) {
            localCahecKey = entityName + String(parentValue);
        }

        let itemA: any = this.GetStorageItem('EntityList', localCahecKey);
        if (ObjectHelper.IsNotNullAndUndefined(itemA)) {
            return itemA;
        }

        let body = ObjectHelper.Empty();
        body['GetEntityListParam'] = {
            "EntityName": entityName,
            "ParentValue": parentValue
        }
        let response = await this.restApiAdapter.Execute(body);
        if (ObjectHelper.IsNotNullAndUndefined(response) && response.hasOwnProperty('data')) {
            let data = response['data'];
            this.SetStorageItem('EntityList', localCahecKey, JSON.stringify(data));
            return this.GetStorageItem('EntityList', localCahecKey);
        }
        return null;
    }

    public async GetEntityListItemDescById(entityName: string, id: number): Promise<string> {
        const list1: Array<any> = await this.GetEntityList(entityName, null);
        if (ObjectHelper.ArrayIs(list1)) {
            const index1: number = ObjectHelper.ArrayIndexByProperty(list1, "Id", id);
            if (index1 >= 0) {
                return list1[index1].Description;
            }
        }
        return null;
    }

    public async GetEntityListItemIdByDesc(entityName: string, desc: string): Promise<number> {
        const list1: Array<any> = await this.GetEntityList(entityName, null);
        if (ObjectHelper.ArrayIs(list1)) {
            const index1: number = ObjectHelper.ArrayIndexByProperty(list1, "Description", desc);
            if (index1 >= 0) {
                return list1[index1].Id;
            }
        }
        return null;
    }

    public async GetGridSettings(entityName: string, gridName: string, settingsType: string, force?: boolean): Promise<any> {
        let localCahecKey = entityName + gridName + settingsType;
        if (this.ExistsStorageItem('GridSettings', localCahecKey)) {
            let itemA: Object = this.GetStorageItem('GridSettings', localCahecKey);
            return itemA;
        }

        let body = {};
        body['GetGridSettingsParam'] = {
            "ProjectionName": entityName,
            "GridName": gridName,
            "GridSettingsType": settingsType
        }

        let response = await this.restApiAdapter.Execute(body);
        if (ObjectHelper.IsNotNullAndUndefined(response) && response.hasOwnProperty('data')) {
            let data = response['data'];
            this.SetStorageItem('GridSettings', localCahecKey, JSON.stringify(data));
            return this.GetStorageItem('GridSettings', localCahecKey);
        }
        return null;
    }

    public async SaveGridSettings(entityName: string, gridName: string, settings: Object, settingsType: string) {
        let localCahecKey = entityName + gridName + settingsType;
        this.SetStorageItem('GridSettings', localCahecKey, JSON.stringify(settings));

        let body = {};
        body['SaveGridSettingsParam'] = {
            "ProjectionName": entityName,
            "GridName": gridName,
            "GridSettings": JSON.parse(JSON.stringify(settings)),
            "GridSettingsType": settingsType
        }
        return await this.restApiAdapter.Execute(body);
    }

    public async GetFilterSettings(entityName: string, columnName: string, filterName: string, filterType: string, force?: boolean): Promise<Array<any>> {
        if (!this.isOnline) {
        }
        else {
            let localCahecKey = entityName + filterName + filterType;
            let itemA: any = this.GetStorageItem('FilterSett', localCahecKey);
            if (ObjectHelper.ArrayIs(itemA) && (ObjectHelper.IsNullOrUndefined(force) || force == false)) {
                return itemA;
            }

            let body = {}
            body['GetFiltersParam'] = {
                "EntityName": entityName,
                "ColumnName": columnName,
                "FilterName": filterName,
                "FilterType": filterType
            }
            let response = await this.restApiAdapter.Execute(body);
            if (ObjectHelper.IsNotNullAndUndefined(response) && response.hasOwnProperty('data')) {
                let data = response['data'];
                this.SetStorageItem('FilterSett', localCahecKey, data);
                return this.GetStorageItem('FilterSett', localCahecKey);
            }
        }

        return [];
    }

    public async GetMenuStatusInfo(): Promise<Object> {
        let body = ObjectHelper.Empty();
        body['GetMenuStatusInfoParam'] = {}
        let response = await this.restApiAdapter.Execute(body);

        if (ObjectHelper.IsNotNullAndUndefined(response) && response.hasOwnProperty('data')) {
            return response['data'];
        }
        return {};
    }

    public async GetPublicEditLayoutForEntity(entityName: string, force?: boolean): Promise<any> {
        let itemA: Object = this.GetStorageItem('PublicEditLayout', entityName);
        if (ObjectHelper.IsNotNullAndUndefined(itemA) && (ObjectHelper.IsNullOrUndefined(force) || force == false)) {
            return itemA;
        }
        let layouts = await this.GetLayoutsByEntity(entityName);
        if (ObjectHelper.IsNotNullAndUndefined(layouts) && ObjectHelper.IsNotNullAndUndefined(layouts['LayoutPublicEdit'])) {
            let data: Layout = new Layout(); // make sure the layout have default values for properties that are not yet in JSON.
            let layoutRaw = <Layout>layouts['LayoutPublicEdit'];
            data = JSON.parse(JSON.stringify(Object.assign(data, layoutRaw)));
            this.SetStorageItem('PublicEditLayout', entityName, JSON.stringify(data));
            return this.GetStorageItem('PublicEditLayout', entityName);
        }
        return null;
    }

    public async GetLayoutBlockSettings(): Promise<Array<any>> {
        let body = ObjectHelper.Empty();
        body['GetLayoutBlockSettingsParam'] = {}
        let response = await this.restApiAdapter.Execute(body);

        if (ObjectHelper.IsNotNullAndUndefined(response) && response.hasOwnProperty('data') && ObjectHelper.ArrayIs(response['data'])) {
            return response['data'];
        }
        return [];
    }

    private async SetEditLayoutBlockSettings(entityName: string, layoutOrg: any): Promise<Layout> {
        let layout: Layout = layoutOrg;
        if (this.globalUserBlockSettings === null) {
            //console.log(55, 'GetLayoutBlockSettings', this.globalUserBlockSettings)
            this.globalUserBlockSettings = await this.GetLayoutBlockSettings();
            //console.log(66, 'GetLayoutBlockSettings', this.globalUserBlockSettings)
        }
        if (!ObjectHelper.ArrayIs(this.globalUserBlockSettings)) {
            return layout;
        }
        const userBlockSettingsArr: Array<any> = this.globalUserBlockSettings.filter((item) => item.ProjectionName == entityName);
        if (ObjectHelper.ArrayIs(userBlockSettingsArr)) {
            for (let rI in layout.EditForm.Rows) {
                for (let bI in layout.EditForm.Rows[rI].Blocks) {
                    for (let sI = 0; sI < userBlockSettingsArr.length; sI++) {
                        const userBlockSettings = userBlockSettingsArr[sI];
                        if (layout.EditForm.Rows[rI].Blocks[bI].Id == userBlockSettings.BlockId) {
                            layout.EditForm.Rows[rI].Blocks[bI].UserPinned = true;
                            layout.EditForm.Rows[rI].Blocks[bI].Collapsed = userBlockSettings.Collapsed;
                        }
                    }
                }
            }
        }
        return layout;
    }

    public async GetEditLayoutForEntity(entityName: string, force?: boolean): Promise<Layout> {
        if (!StringHelper.StringIs(entityName)) {
            return null;
        }
        let itemA: Object = this.GetStorageItem('EditLayout', entityName);
        if (ObjectHelper.IsNotNullAndUndefined(itemA) && (ObjectHelper.IsNullOrUndefined(force) || force == false)) {
            return await this.SetEditLayoutBlockSettings(entityName, itemA);
        }

        let schema: any = await this.GetSchemaByEntity(entityName);
        let layouts = await this.GetLayoutsByEntity(entityName);
        let accessRight: any = await this.GetAccessRightByEntity(entityName);

        if (ObjectHelper.IsNotNullAndUndefined(layouts) && ObjectHelper.IsNotNullAndUndefined(layouts['LayoutEdit'])) {
            // get data
            let data: Layout = new Layout(); // make sure the layout have default values for properties that are not yet in JSON.
            let layoutRaw = <Layout>layouts['LayoutEdit'];
            if (ObjectHelper.IsNotNullAndUndefined(layoutRaw)) {
                let schemaGlobal = await this.GetSchema();
                if (ObjectHelper.IsNotNullAndUndefined(layoutRaw.Subgrids)) {
                    layoutRaw.Subgrids = layoutRaw.Subgrids.filter(s => s != null && schemaGlobal['Entities'].filter(e => e['EntityName'] == s.EntityName).length > 0);
                }
                if (ObjectHelper.IsNotNullAndUndefined(layoutRaw.EditForm) && ObjectHelper.IsNotNullAndUndefined(layoutRaw.EditForm.Rows) && layoutRaw.EditForm.Rows.length > 0) {
                    for (let iR = 0; iR < layoutRaw.EditForm.Rows.length; iR++) {
                        if (ObjectHelper.IsNotNullAndUndefined(layoutRaw.EditForm.Rows[iR].Blocks) && layoutRaw.EditForm.Rows[iR].Blocks.length > 0) {
                            for (let iB = 0; iB < layoutRaw.EditForm.Rows[iR].Blocks.length; iB++) {
                                if (layoutRaw.EditForm.Rows[iR].Blocks[iB].BlockType == 'Form' && ObjectHelper.IsNotNullAndUndefined(layoutRaw.EditForm.Rows[iR].Blocks[iB].Columns) && layoutRaw.EditForm.Rows[iR].Blocks[iB].Columns.length > 0) {
                                    for (let iC = 0; iC < layoutRaw.EditForm.Rows[iR].Blocks[iB].Columns.length; iC++) {
                                        if (ObjectHelper.IsNotNullAndUndefined(layoutRaw.EditForm.Rows[iR].Blocks[iB].Columns[iC].Fields) && layoutRaw.EditForm.Rows[iR].Blocks[iB].Columns[iC].Fields.length > 0) {
                                            layoutRaw.EditForm.Rows[iR].Blocks[iB].Columns[iC].Fields = layoutRaw.EditForm.Rows[iR].Blocks[iB].Columns[iC].Fields.filter(s => schema['Columns'].filter(e => e['ColumnName'] == s.FieldName).length > 0);
                                        }
                                    }
                                    layoutRaw.EditForm.Rows[iR].Blocks[iB].Columns = layoutRaw.EditForm.Rows[iR].Blocks[iB].Columns.filter(c => c.Fields != null && c.Fields.length > 0);
                                }
                            }
                            layoutRaw.EditForm.Rows[iR].Blocks = layoutRaw.EditForm.Rows[iR].Blocks.filter(c =>
                                (c.BlockType == 'Form' && c.Columns != null && c.Columns.length > 0)
                                || (c.BlockType == 'Category')
                                || (c.BlockType == 'Participant' && accessRight.ReadParticipants)
                                || (c.BlockType == 'DiscussionSendMess' && accessRight.DiscussionCreate && schema.DiscussionEnabled)
                                || (c.BlockType == 'DocumentUpload' && accessRight.DocumentCreate && schema.DocumentEnabled)
                                || (c.BlockType == 'ItemGrid' && schemaGlobal['Entities'].filter(e => e['EntityName'] == c.EntityName).length > 0)
                                || (c.BlockType == 'ItemMasterGrid')
                                || (c.BlockType == 'PriceSummary')
                                || (c.BlockType == 'ManyToMany')
                                || (c.BlockType == 'EmailAttachment')
                                || (c.BlockType == 'EmailAttachmentList')
                            );
                        }
                    }
                    layoutRaw.EditForm.Rows = layoutRaw.EditForm.Rows.filter(c => c.Blocks != null && c.Blocks.length > 0);
                }
            }

            data = JSON.parse(JSON.stringify(Object.assign(data, layoutRaw)));
            this.SetStorageItem('EditLayout', entityName, JSON.stringify(data));
            return await this.SetEditLayoutBlockSettings(entityName, this.GetStorageItem('EditLayout', entityName));
        }
        return null;
    }

    public async GetListLayoutForEntity(entityName: string, force?: boolean): Promise<any> {
        let itemA: Object = this.GetStorageItem('ListLayout', entityName);
        if (ObjectHelper.IsNotNullAndUndefined(itemA) && (ObjectHelper.IsNullOrUndefined(force) || force == false)) {
            return itemA;
        }

        let layouts = await this.GetLayoutsByEntity(entityName);
        if (ObjectHelper.IsNotNullAndUndefined(layouts) && ObjectHelper.IsNotNullAndUndefined(layouts['LayoutList'])) {
            let schema = await this.GetSchema();
            // get data
            let data: Layout = new Layout(); // make sure the layout have default values for properties that are not yet in JSON.
            let layoutRaw = <Layout>layouts['LayoutList'];
            if (ObjectHelper.IsNotNullAndUndefined(layoutRaw) && ObjectHelper.IsNotNullAndUndefined(layoutRaw.Subgrids)) {
                layoutRaw.Subgrids = layoutRaw.Subgrids.filter(s => schema['Entities'].filter(e => e['EntityName'] == s.EntityName).length > 0);
            }
            data = Object.assign(data, layoutRaw);
            this.SetStorageItem('ListLayout', entityName, JSON.stringify(data));
            return this.GetStorageItem('ListLayout', entityName);
        }
        return null;
    }

    public async GetDashboardLayoutForEntity(entityName: string, force?: boolean): Promise<any> {
        let itemA: Object = this.GetStorageItem('DashLayout', entityName);
        if (ObjectHelper.IsNotNullAndUndefined(itemA) && (ObjectHelper.IsNullOrUndefined(force) || force == false)) {
            return itemA;
        }

        let layouts = await this.GetLayoutsByEntity(entityName);
        if (ObjectHelper.IsNotNullAndUndefined(layouts) && ObjectHelper.IsNotNullAndUndefined(layouts['LayoutDashboard'])) {
            // get data
            let data: Layout = new Layout(); // make sure the layout have default values for properties that are not yet in JSON.
            let layoutRaw = <Layout>layouts['LayoutDashboard'];
            data = JSON.parse(JSON.stringify(Object.assign(data, layoutRaw)));
            this.SetStorageItem('DashLayout', entityName, JSON.stringify(data));
            return this.GetStorageItem('DashLayout', entityName);
        }
        return null;
    }
    public async SaveLayoutBlockSettings(entityName: string, blockId: string, collapsed: boolean) {
        if (this.globalUserBlockSettings === null) {
            this.globalUserBlockSettings = [];
        }
        if (this.globalUserBlockSettings != null) {
            if (collapsed === null) {
                this.globalUserBlockSettings = this.globalUserBlockSettings.filter((i) => !(i.ProjectionName == entityName && i.BlockId == blockId));
            }
            else {
                for (let i1 = 0; i1 < this.globalUserBlockSettings.length; i1++) {
                    if (this.globalUserBlockSettings[i1].ProjectionName == entityName && this.globalUserBlockSettings[i1].BlockId == blockId) {
                        this.globalUserBlockSettings[i1].Collapsed = collapsed;
                    }
                }
                if (this.globalUserBlockSettings.filter((i) => i.ProjectionName == entityName && i.BlockId == blockId).length == 0) {
                    this.globalUserBlockSettings.push({
                        ProjectionName: entityName,
                        BlockId: blockId,
                        Collapsed: collapsed
                    });
                }
            }
        }

        let body = {};
        body['SaveLayoutBlockSettingsParam'] = {
            "ProjectionName": entityName,
            "BlockId": blockId,
            "Collapsed": collapsed
        }
        return await this.restApiAdapter.Execute(body);
    }

    public async SaveLayoutForEntity(entityName: string, mode: string, layout: Layout, profileId: number) {
        if (!StringHelper.StringIs(entityName)) {
            return null;
        }
        let schemaLayout = await this.GetSchemaLayout();

        let modeTemp = mode;
        let cahecKey = '';
        switch (mode) {
            case 'edit':
            case 'quick':
            case 'create': {
                cahecKey = 'EditLayout';
                for (let rI in layout.EditForm.Rows) {
                    for (let bI in layout.EditForm.Rows[rI].Blocks) {
                        layout.EditForm.Rows[rI].Blocks[bI].UserPinned = false;
                    }
                }

                if (ObjectHelper.IsNotNullAndUndefined(schemaLayout)) {
                    schemaLayout['Entities'].filter((item) => item['EntityName'] == entityName)[0]['LayoutEdit'] = JSON.parse(JSON.stringify(layout));
                }
                modeTemp = 'edit';
            } break;
            case 'list':
            case 'email': {
                cahecKey = 'ListLayout';
                if (ObjectHelper.IsNotNullAndUndefined(schemaLayout)) {
                    let entityObj = schemaLayout['Entities'].filter((item) => item['EntityName'] == entityName);
                    if (ObjectHelper.IsNotNullAndUndefined(entityObj) && entityObj.length > 0) {
                        entityObj[0]['LayoutList'] = JSON.parse(JSON.stringify(layout));
                    }
                }
                modeTemp = 'list';
            } break;
            case 'dashboard': {
                cahecKey = 'DashLayout';
                if (ObjectHelper.IsNotNullAndUndefined(schemaLayout)) {
                    let entityObj = schemaLayout['Entities'].filter((item) => item['EntityName'] == entityName);
                    if (ObjectHelper.IsNotNullAndUndefined(entityObj) && entityObj.length > 0) {
                        entityObj[0]['LayoutDashboard'] = JSON.parse(JSON.stringify(layout));
                    }
                }
                modeTemp = 'dashboard';
            } break;
        }

        this.SetStorageItem(cahecKey, entityName, JSON.stringify(layout));

        let body = {};
        body['SaveLayoutParam'] = {
            "EntityName": entityName,
            "Mode": modeTemp,
            "Layout": layout
        }

        return await this.restApiAdapter.Execute(body);
    }

    public async ResetLayoutForEntity(entityName: string) {
        let body = {};
        body['ResetLayoutParam'] = {
            "EntityName": entityName
        }

        return await this.restApiAdapter.Execute(body);
    }

    public async SaveDashboardLayoutForEntity(entityName: string, mode: string, layout: DashboardLayout, profileId: number) {
        if (!StringHelper.StringIs(entityName)) {
            return null;
        }
        let schemaLayout = await this.GetSchemaLayout();

        let modeTemp = mode;
        let cahecKey = '';
        switch (mode) {
            case 'dashboard': {
                cahecKey = 'DashLayout';
                if (ObjectHelper.IsNotNullAndUndefined(schemaLayout)) {
                    let entityObj = schemaLayout['Entities'].filter((item) => item['EntityName'] == entityName);
                    if (ObjectHelper.IsNotNullAndUndefined(entityObj) && entityObj.length > 0) {
                        entityObj[0]['LayoutDashboard'] = JSON.parse(JSON.stringify(layout));
                    }
                }
                modeTemp = 'dashboard';
            } break;
        }

        this.SetStorageItem(cahecKey, entityName, JSON.stringify(layout));

        let body = {};
        body['SaveLayoutParam'] = {
            "EntityName": entityName,
            "Mode": modeTemp,
            "Layout": layout
        }

        return await this.restApiAdapter.Execute(body);
    }

    public async GetDevice() {
        let deviceName: string = await this.restApiAdapter.GetDevice();
        //console.log(99999999999999999999, "deviceName", deviceName);
        return deviceName;
    }

    public async GetNavigatorUserAgent() {
        return await this.restApiAdapter.GetNavigatorUserAgent();
    }

    public async IsMobileDevice1() {
        return await this.restApiAdapter.IsMobileDevice1();
    }
    public async IsMobileDevice2() {
        return await this.restApiAdapter.IsMobileDevice2();
    }

    public async GetEnumerationItemById(enumType: string, id: number): Promise<Object> {
        if (StringHelper.StringIs(enumType) && ObjectHelper.ObjectIs(id) && typeof id === 'number' && id > 0) {
            let enumType1: Object = await this.GetEnumeration(enumType, null, null);
            let enums: Array<any> = enumType1['Items'];
            if (ObjectHelper.IsNotNullAndUndefined(enums) && enums.length > 0) {
                let filterEnums: Array<any> = enums.filter((item) => item.Id == id);
                if (ObjectHelper.IsNotNullAndUndefined(filterEnums) && filterEnums.length > 0) {
                    return filterEnums[0];
                }
            }
        }
        return null;
    }
    public async GetEnumerationItem(enumType: string, desc: string, parentValue: number): Promise<Object> {
        let enumType1: Object = await this.GetEnumeration(enumType, parentValue, null);
        let enums: Array<any> = enumType1['Items'];
        if (ObjectHelper.IsNotNullAndUndefined(enums) && enums.length > 0) {
            let filterEnums: Array<any> = enums.filter((item) => item.Description == desc);
            if (ObjectHelper.IsNotNullAndUndefined(filterEnums) && filterEnums.length > 0) {
                return filterEnums[0];
            }
        }
        return null;
    }
    public async GetEnumerationFirstItemId(enumType: string, parentValue: number): Promise<number> {
        let enumType1: Object = await this.GetEnumeration(enumType, parentValue, null);
        let enums: Array<any> = enumType1['Items'];
        if (ObjectHelper.IsNotNullAndUndefined(enums) && enums.length > 0) {
            return enums[0].Id;
        }
        return null;
    }
    public async GetEnumerationItemId(enumType: string, desc: string, parentValue: number): Promise<number> {
        const enumItem: any = await this.GetEnumerationItem(enumType, desc, parentValue);
        if (ObjectHelper.IsNotNullAndUndefined(enumItem)) {
            return enumItem.Id;
        }
        return null;
    }
    public async GetEnumerationItemCaptionById(enumType: string, id: number): Promise<string> {
        if (StringHelper.StringIs(enumType) && typeof id === 'number' && id > 0) {
            const enumItem: any = await this.GetEnumerationItemById(enumType, id);
            if (ObjectHelper.IsNotNullAndUndefined(enumItem)) {
                return enumItem.Caption;
            }
        }
        return null;
    }

    public async GetEnumerationItemDescriptionById(enumType: string, id: number): Promise<string> {
        if (StringHelper.StringIs(enumType) && typeof id === 'number' && id > 0) {
            const enumItem: any = await this.GetEnumerationItemById(enumType, id);
            if (ObjectHelper.IsNotNullAndUndefined(enumItem)) {
                return enumItem.Description;
            }
        }
        return null;
    }

    public async GetEnumeration(enumType: string, parentValue: number, filterText: string): Promise<Object> {
        if (StringHelper.IsNullOrEmptyOrUndefined(enumType))
            return null;

        let localCahecKey = enumType;
        if (ObjectHelper.IsNotNullAndUndefined(parentValue)) {
            localCahecKey = enumType + String(parentValue);
        }
        if (!StringHelper.IsNullOrEmpty(filterText)) {
            localCahecKey = null; // musim hledat v DB podle filtru
        }
        let itemA: Object = this.GetStorageItem('Enum', localCahecKey);
        if (ObjectHelper.IsNotNullAndUndefined(itemA)) {
            return itemA;
        }
        if (!this.isOnline) {
        }
        else {
            let body = ObjectHelper.Empty();
            body['GetEnumerationParam'] = {
                "EnumerationType": enumType,
                "ParentValue": parentValue,
                "FilterText": filterText
            }
            let response = await this.restApiAdapter.Execute(body);
            if (ObjectHelper.IsNotNullAndUndefined(response) && response.hasOwnProperty('data')) {
                let data = response['data'];

                this.SetStorageItem('Enum', localCahecKey, JSON.stringify(data));
                return this.GetStorageItem('Enum', localCahecKey);
            }
        }
        return null;
    }

    public async GetEntityEnumeration(entityName: string) {
        let itemA: Object = this.GetStorageItem('EntityEnum', entityName);
        if (ObjectHelper.IsNotNullAndUndefined(itemA)) {
            return itemA;
        }

        let schema = await this.GetSchema();
        if (ObjectHelper.IsNotNullAndUndefined(schema) && schema.hasOwnProperty(entityName)) {
            this.SetStorageItem('EntityEnum', entityName, JSON.stringify(schema[entityName]));
            return this.GetStorageItem('EntityEnum', entityName);
        }
        else {
            // return null
        }
    }

    public async GetEntityEnumerationById(entityName: string, entityId: number) {
        let itemA: Object = this.GetStorageItem('EntityEnumById', entityName + entityId);
        if (ObjectHelper.IsNotNullAndUndefined(itemA)) {
            return itemA;
        }
        let entityEnumeration = await this.GetEntityEnumeration(entityName);
        if (ObjectHelper.IsNotNullAndUndefined(entityEnumeration) && entityEnumeration.length > 0) {
            let filteredData = entityEnumeration.filter((item) => item.hasOwnProperty('Id') && item['Id'] == entityId);
            if (ObjectHelper.IsNotNullAndUndefined(filteredData) && filteredData.length > 0) {
                this.SetStorageItem('EntityEnumById', entityName + entityId, JSON.stringify(filteredData[0]));
                return this.GetStorageItem('EntityEnumById', entityName + entityId);
            }
        }
        else {
            return null;
        }
    }
}
